import BillingDashboard from '@/models/general/settings/BillingDashboard';
import { formatBillingPeriodValue } from '@/utils/helpers';
import moment from 'moment/moment';

const getDefaultState = () => ({
  subscription: {},
  subscriptionPlan: {},
  currentBilling: {},
  subscriptionPlans: [],
  subscriptionPlansPagination: {},
});

export default {
  namespaced: true,
  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setSubscription(state, payload) {
      state.subscription = payload;
      state.subscription.unpaid_billings = payload?.unpaid_billings?.map((b) => {
        b.updated_at = moment(b.updated_at).format('DD/MM/YYYY HH:mm');
        b.periodVal = formatBillingPeriodValue(b);
        return b;
      });
    },
    setSubscriptionPlan(state, payload) {
      state.subscriptionPlan = payload;
    },
    setCurrentBilling(state, payload) {
      state.currentBilling = payload;
    },
    setSubscriptionPlans(state, payload) {
      state.subscriptionPlans = payload;
    },
    setSubscriptionPlansPagination(state, payload) {
      state.subscriptionPlansPagination = payload;
    },
  },

  actions: {
    async getCurrent({ commit, state }) {
      try {
        const { data } = await BillingDashboard.getCurrent();

        let subscription = { ...data.data.subscription };
        commit('setCurrentBilling', subscription.current_billing);
        delete subscription.current_billing;
        commit('setSubscriptionPlan', {
          ...subscription.store_subscription_plan,
        });
        delete subscription.store_subscription_plan;

        commit('setSubscription', subscription);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async updatePaymentDue({ commit, state }, payload) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.updatePaymentDue(payload);
        if (data.error) {
          commit('setErrorMessage', data.message, { root: true });
          return;
        }
        let subscription = { ...data.data.subscription };

        commit('setCurrentBilling', subscription.current_billing);
        delete subscription.current_billing;

        commit('setSubscriptionPlan', subscription.store_subscription_plan);
        delete subscription.store_subscription_plan;

        commit('setSubscription', subscription);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit(
          'setNotification',
          {
            show: true,
            type: 'error',
            text: ex.response?.data.message,
          },
          { root: true }
        );
        console.log('ERROR MESSAGE: ', ex.response?.data.message);
      }
    },

    async getSubscriptionPlans({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.getSubscriptionPlans(body.query);
        if (body.page == 1) {
          commit('setSubscriptionPlans', data.data.results);
        } else {
          const plans = state.subscriptionPlans;
          data.data.results.map((item) => {
            plans.push(item);
          });
          commit('setSubscriptionPlans', plans);
        }

        commit('setSubscriptionPlansPagination', data.data.pagination);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },

    async changeSubscriptionPlan({ commit, state }, body) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await BillingDashboard.changeSubscriptionPlan(body);

        commit('setLoading', false, { root: true });

        return data;
      } catch (ex) {
        commit('setLoading', false, { root: true });
        commit('setErrorMessage', ex.response?.data.message, {
          root: true,
        });
        setTimeout(() => commit('setErrorMessage', '', { root: true }), 5000);
      }
    },
  },
};
